module.exports = __webpack_public_path__ + "poster3.png";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/pages/newLandingPage/block-slider/сomponents/auto-slider/assets/poster3.png
// module id = 1133
// module chunks = 10